
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { configStore, uiStore } from "@/store/store";
import IconButton from "@/components/UI/IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { isUiPanelOpen, openUiPanel } from "@/lib/panels/panels";
import StandardButton from "@/components/UI/StandardButton.vue";
import Icon from "@/components/UI/Icon.vue";
import { switchToSingularityMode } from "@/futurelayer/ui/ui";

@Component({
  components: {
    Icon,
    StandardButton,
    Dropdown,
    IconButton
  }
})
export default class SettingsDropdown extends Vue {
  isOpen = false;

  get builderMode() {
    return configStore.builderMode;
  }

  get nudgeTop() {
    return this.builderMode === "oxygen" ? -16 : 0;
  }

  openPreferencesModal() {
    uiStore.setPreferencesModalOpen(true);
  }

  toggleElementStudio() {
    uiStore.toggleElementStudio();
  }

  openGlobalSettingsPanel() {
    openUiPanel("globalSettings");
  }

  openSelectorsPanel() {
    uiStore.setActiveSelectorName(null);
    openUiPanel("selectors");
  }

  openPresetsPanel() {
    uiStore.setActivePresetId(null);
    openUiPanel("presets");
  }

  get elementsLoadingState() {
    return configStore.elementsLoadingState;
  }

  get anySettingsPanelsOpen() {
    return (
      isUiPanelOpen("selectors") ||
      isUiPanelOpen("history") ||
      isUiPanelOpen("globalSettings") ||
      uiStore.panelState.elementStudioOpen ||
      uiStore.panelState.preferencesModalOpen
    );
  }

  openHistoryAndRevisionsPanel() {
    openUiPanel("history");
  }

  get globalSettingsAvailableForEditing() {
    return configStore.globalSettingsControlsAndTemplate.controls.length > 0;
  }

  toggleAiSiteCreationExperience() {
    switchToSingularityMode();
  }

  get aiSiteCreationExperienceAvailable() {
    return !!window.Breakdance?.singularity;
  }
}
